import "../styles/layout-blog.css";

import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  EmailIcon,
  EmailShareButton,
  FacebookIcon,
  FacebookShareButton,
  LinkedinIcon,
  LinkedinShareButton,
  TwitterShareButton,
  WhatsappIcon,
  WhatsappShareButton,
  XIcon
} from "react-share";
import { t } from "../../translations";
import { createLogger } from "../../utils/logger";

const logger = createLogger("BlogBanner");

const BlogBanner = (props) => {
  const { chef_data, title, createdAt, updatedAt, pic, message } = props;
  const lang = useSelector((state) => state.lang);

  function transformDateString(isoString) {
    // Crée un objet Date à partir de la chaîne ISO 8601
    const date = new Date(isoString);

    // Récupère le jour, le mois et l'année
    const day = String(date.getUTCDate()).padStart(2, "0");
    const month = String(date.getUTCMonth() + 1).padStart(2, "0"); // Les mois commencent à 0
    const year = date.getUTCFullYear();

    // Formate la date comme "09-07-2024"
    const formattedDate = `${day}-${month}-${year}`;

    return formattedDate;
  }

  function truncateText(text, maxWords = 13) {
    if (text) {
      const words = text.split(" ");
      if (words.length > maxWords) {
        return words.slice(0, maxWords).join(" ") + "...";
      }
    }
    return text;
  }

  const [summary, setSummary] = useState();

  useEffect(() => {
    setSummary(truncateText(message));
  }, [props?.message]);

  useEffect(() => {
    logger.log(summary);
  }, [summary]);

  const formattedUpdatedDate = transformDateString(updatedAt);
  const formattedDate = transformDateString(createdAt);

  // const url = document.location.href
  const url = "https://github.com";

  return (
    <div style={{ textAlign: "start" }}>
      <h6 style={{ fontSize: "25px", fontWeight: "500", color: "#FF114D" }}>
        Blog
      </h6>
      <h1 className="title-h1-header-blog">{title}</h1>
      <div className="header-chef">
        <div className="header-chef-imgContainer">
          <img src={chef_data?.pic1} alt="" />
        </div>
        <h6 className="title-h6-header-blog">
          {`${chef_data?.firstname + " " + chef_data?.lastname} | ${t("common.published", lang)}  ${formattedDate}`}{" "}
          <br />
          {`${t("common.updated", lang)} ${formattedUpdatedDate}`}
        </h6>
        <div className="icon-header">
          <FacebookShareButton url={url} hashtag="#PANI">
            <FacebookIcon className="blog-header-icon" />
          </FacebookShareButton>
          <LinkedinShareButton
            url={url}
            title={title}
            summary={summary}
            source={"Panichef.com"}
          >
            <LinkedinIcon className="blog-header-icon" />
          </LinkedinShareButton>
          <TwitterShareButton url={url}>
            <XIcon className="blog-header-icon" />
          </TwitterShareButton>
          <EmailShareButton
            subject={title}
            url={url}
            body={`J'espère que vous allez bien. Je suis ravi
                    de partager avec vous notre dernier article de blog 
                    sur PANI Blog. Dans cet article intitulé "${title}", nous 
                    vous invitons à découvrir avec ${chef_data?.firstname + " " + chef_data?.lastname}, 
                    de nouvelles approches pour aborder la cuisine. 
                    Vous y trouverez des conseils pratiques, des recettes 
                    savoureuses et des astuces.`}
          >
            <EmailIcon className="blog-header-icon" />
          </EmailShareButton>
          <WhatsappShareButton url={url}>
            <WhatsappIcon className="blog-header-icon" />
          </WhatsappShareButton>
        </div>
      </div>
      <div className="icon-header-small">
        <FacebookShareButton>
          <FacebookIcon className="blog-header-icon" />
        </FacebookShareButton>
        <LinkedinShareButton>
          <LinkedinIcon className="blog-header-icon" />
        </LinkedinShareButton>
        <TwitterShareButton>
          <XIcon className="blog-header-icon" />
        </TwitterShareButton>
        <EmailShareButton>
          <EmailIcon className="blog-header-icon" />
        </EmailShareButton>
        <WhatsappShareButton>
          <WhatsappIcon className="blog-header-icon" />
        </WhatsappShareButton>
      </div>
      <div className="img-headerContainer">
        <img src={pic} alt="" />
      </div>
    </div>
  );
};

export default BlogBanner;
